/** @jsx jsx */

import { css as _css } from 'emotion';
import { css, jsx } from '@emotion/core';
import { colors } from 'styles/variables';
import TopicPanelDefaultIcon from 'assets/PortalAvatar.svg'; // TopicPanelDefaultIcon.png';
import { useCachedResource } from 'services/useCachedResource';
import { CHAMELEON_CACHE_v1 } from 'services/imageCache';

const { lPink } = colors;

const TopicIcon = ({
  topicIcon,
  size = 60,
  isEditing,
  iconSelected,
  setIconSelected,
}) => {
  const src = topicIcon?.url || TopicPanelDefaultIcon;
  const cachedImgSrc = useCachedResource(CHAMELEON_CACHE_v1, src);

  return (
    <div
      css={css`
        position: absolute;
        display: flex;
        justify-content: center;
        left: 0;
        top: 0;
        width: inherit;
        height: ${size}px;
      `}
    >
      <div
        css={css`
          flex-stretch: 0;
          width: ${size}px;
          height: ${size}px;
          border-radius: 50%;
          background: url('${cachedImgSrc || src}') no-repeat;
          background-size: cover;
          ${isEditing &&
            `
            cursor: pointer;
            &:hover {
              transition: box-shadow 0.15s;
              box-shadow: 0 0 0 2px ${lPink};
            }
            `}
        `}
        onClick={
          isEditing
            ? e => {
                e.stopPropagation();
                setIconSelected(!iconSelected);
              }
            : () => {}
        }
      />
    </div>
  );
};

export default TopicIcon;
